import { Button, Dialog, Grid, Zoom } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import React from "react";
import { useDispatch } from "react-redux";
import Apis from "../../../../../../constants/Api";
import { showError, showSuccess } from "../../../../actions";
import history from "../../../../../../utilize/history";
import { removeMyActivity } from "routes/actions";
import Axios from "screens/EnghelabSchoolForm/axios";

const useStyles = makeStyles((theme) => ({
  paper: {
    borderRadius: 10,
    padding: 15,
    maxWidth: "90%",
  },
  root: {
    width: "fit-content",
    backgroundColor: "#fff",
    padding: 10,
  },
  title: {
    fontSize: 22,
    marginBottom: 25,
  },
  confirmButton: {
    backgroundColor: "#2bb1c1",
    color: "#fff",
    borderRadius: 8,
    marginRight: 20,
    height: 35,
    width: 75,
  },
  cancelButton: {
    borderRadius: 8,
    height: 35,
    width: 75,
  },
}));
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom direction="up" ref={ref} {...props} />;
});
export default function DeleteActivityDialog({
  slug,
  deleteDialog,
  setDeleteDialog,
  setAcceptAccept,
  enghlabSchool = null,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const deleteActivity = async () => {
    var myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      `token ${localStorage.getItem("aghighToken")}`
    );

    var formData = new FormData();

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formData,
      redirect: "follow",
    };

    fetch(Apis.baseUrl + `a/act/activity-remove/${slug}/`, requestOptions)
      .then((response) => {
        if (response.status === 200 || response.status === 204) {
          setDeleteDialog(false);
          dispatch(showSuccess({ message: "فعالیت با موفقیت حذف شد" }));
          setAcceptAccept(true);
          dispatch(removeMyActivity(slug));

          history.push("/activities/myactivity");
        } else {
          setDeleteDialog(false);
          dispatch(showError({ message: "خطایی رخ داده است" }));
        }
      })
      .catch((error) => {
        dispatch(showError({ message: "خطایی رخ داده است" }));
      });

    try {
      const { data } = await Axios.get("a/enghelab-school/group/");
      if (data) {
        let { _id } = data;
        const { data: hiss } = await Axios.get(
          `a/enghelab-school/group/activity-history/${_id}/`
        );
        if (hiss?.length > 0) {
          let his = hiss.find((item) => item.activity_slug === slug);
          if (his) {
            await Axios.delete(
              `a/enghelab-school/act/report/${slug}/`
            );
          }
        }
      }
    } catch (error) {}
  };
  return (
    <Dialog
      open={deleteDialog}
      TransitionComponent={Transition}
      maxWidth="xl"
      classes={{ paper: classes.paper }}
      onClose={() => setDeleteDialog(false)}
      style={{ zIndex: 3000 }}
    >
      <Grid container direction="column">
        <Grid container className={classes.title}>
          آیا از حذف فعالیت مطمئن هستید؟
        </Grid>
        <Grid container justify="center">
          <Button
            variant="contained"
            className={classes.confirmButton}
            onClick={() => (enghlabSchool ? enghlabSchool() : deleteActivity())}
          >
            تایید
          </Button>
          <Button
            variant="outlined"
            className={classes.cancelButton}
            onClick={() => setDeleteDialog(false)}
          >
            انصراف
          </Button>
        </Grid>
      </Grid>
    </Dialog>
  );
}
